const API_BASE_URL = '/api';

class LogService {
  getToken() {
    return localStorage.getItem('auth_token');
  }

  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const token = this.getToken();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
      ...options,
    };
    const response = await fetch(url, config);
    const data = await response.json();
    if (!response.ok) {
      // Auto-logout jika token expired
      if (response.status === 401 && data.error && data.error.includes('Token expired')) {
        window.dispatchEvent(new CustomEvent('auth:token-expired'));
      }
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }
    return data;
  }

  async getLogs(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/logs${query ? `?${query}` : ''}`);
  }

  async getRecentLogs() {
    return this.request('/logs/recent');
  }

  async getLogStats() {
    return this.request('/logs/stats');
  }
}

export const logService = new LogService();
export default logService;
